import utagLinkGeneric from './utagLinkGeneric';
import { setGenericEvent } from './ga4/custom';

let forceRemoveErrors = [];

function getErrorMessage (errorCode) {

	switch (errorCode) {

		case 'product-unavailable':
			return 'Product Unavailable';
		case 'delivery-unavailable':
			return 'Shipping Unavailable';
		default:
			return '';

	}

}

function getEventCategory () {

	switch (window.utag_data.page_type.toLowerCase()) {

		case 'cart':
			return 'Cart';
		case 'shipping':
			return 'Shipping';
		default:
			return '';

	}

}

function trackCartForceRemoveError ({
	errorCode, shortSku, cartId, eventAction = 'Error-Product'
}) {

	try {

		const eventLabel = `${getErrorMessage(errorCode)} - ${shortSku} - ${cartId}`;
		const errorIndex = forceRemoveErrors.findIndex((sku) => sku.shortSku === shortSku);
		// only run for cart and shipping pages
		const eventCategory = getEventCategory();

		// abandon if page type is not in scope
		if (!eventCategory) {

			return;

		}

		if (errorIndex > -1) {

			const { errorCodes } = forceRemoveErrors[errorIndex];
			const errorNotReported = errorCodes.findIndex((code) => code === errorCode) === -1;

			if (errorNotReported) {

				utagLinkGeneric({
					eventCategory,
					eventAction,
					eventLabel
				});
				forceRemoveErrors = [
					...forceRemoveErrors.slice(0, errorIndex),
					{
						...forceRemoveErrors[errorIndex],
						errorCodes: [ ...forceRemoveErrors[errorIndex].errorCodes, errorCode ]
					},
					...forceRemoveErrors.slice(errorIndex + 1)
				];

			}

		} else {

			utagLinkGeneric({
				eventCategory,
				eventAction,
				eventLabel
			});

			if (window.utag_data.user_type.toLowerCase() !== 'hospitality') {

				setGenericEvent({
					event_name: 'cart_product_error',
					error_message: eventLabel
				});

			}

			forceRemoveErrors.push({
				shortSku,
				errorCodes: [ errorCode ]
			});

		}

	} catch (error) {

		console.error(`Cart Error Tracking exception: ${error.message}`);

	}

}

export default trackCartForceRemoveError;
